export default __webpack_public_path__ + "static/media/note-add-new-icon.7d5f687e.svg";